import React from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import './suneditor-custom.css';

interface SunTextEditorProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const SunTextEditor: React.FC<SunTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Write something...',
  readOnly = false,
  className = '',
  style = {},
}) => {
  // Configure SunEditor
  const options = {
    height: 'auto',
    minHeight: '200px',
    buttonList: [
      ['undo', 'redo'],
      ['font', 'fontSize', 'formatBlock'],
      ['bold', 'underline', 'italic', 'strike'],
      ['fontColor', 'hiliteColor'],
      ['removeFormat'],
      ['outdent', 'indent'],
      ['align', 'list'],
      ['table', 'link', 'image'],
      ['fullScreen', 'codeView'],
    ],
    // Table plugin options
    table: {
      maxCellCount: 100,
      maxRowCount: 50,
      defaultCellWidth: 100,
    },
  };

  // Handle content changes
  const handleChange = (content: string) => {
    onChange(content);
  };

  return (
    <div className={className} style={style}>
      <SunEditor
        setContents={value}
        onChange={handleChange}
        setOptions={options}
        placeholder={placeholder}
        disable={readOnly}
        setDefaultStyle="font-family: Arial, sans-serif; font-size: 14px;"
      />
    </div>
  );
};

export default SunTextEditor;
